<div class="col-12">
  <div class="col-3">
    <p-fieldset [legend]="('UPLOAD_COMPONENT.CREATE_PREVIEW_TITLE' | translate) + '*'">

      <div class="col-12 drop-down-container">
        <div>
          <p-inputSwitch [pTooltip]="" [(ngModel)]="useGrayColor" (onChange)="setExpressDepositMargins()"></p-inputSwitch>
        </div>
        <div class="option-label">{{'UPLOAD_COMPONENT.CREATE_COLOR_SWITCH' | translate}}</div>
      </div>
      <div class="col-12 drop-down-container">
        <div>
          <p-inputSwitch [(ngModel)]="setMargins" (onChange)="initMargins()"></p-inputSwitch>
        </div>
        <div class="option-label">{{'UPLOAD_COMPONENT.CREATE_PREVIEW_SWITCH' | translate}}</div>
      </div>
      <div class="col-12" *ngIf="setMargins">
        <h3>{{'UPLOAD_COMPONENT.CREATE_PREVIEW_LABEL' | translate}}: {{userMargins}} MM</h3>
        <p-slider [(ngModel)]="userMargins" [style]="{'width':'14em'}" [step]="1" [min]="0" [max]="10"
                  (onSlideEnd)="setExpressDepositMargins()" (onChange)="setExpressDepositMargins()"></p-slider>
      </div>
      <div class="col-12 " style="color: #007ad9;">
        <p>* {{'UPLOAD_COMPONENT.CREATE_MARGINS_NOTE1' | translate}}</p>
        <p>{{'UPLOAD_COMPONENT.CREATE_MARGINS_NOTE2' | translate}}</p>
      </div>
    </p-fieldset>
    <p-fieldset [legend]="('UPLOAD_COMPONENT.CREATE_PREVIEW_PA_TITLE' | translate) + '*'">
      <div class="col-12 drop-down-container">
        <div>
          <p-inputSwitch [pTooltip]="" [(ngModel)]="addAddressPage" (onChange)="setExpressDepositMargins()"></p-inputSwitch>
        </div>
        <div class="option-label">{{'UPLOAD_COMPONENT.CREATE_PA_SWITCH' | translate}}</div>
      </div>
    </p-fieldset>

  </div>
  <div class="col-6 viewer-container">
    <div class="col-12" *ngIf="showPaginator">
      <p-paginator [rows]="1" [totalRecords]="foldCount" [showCurrentPageReport]="true"
                   [currentPageReportTemplate]="'Pli:  {currentPage} / {totalPages}'"
                   (onPageChange)="paginate($event)">
      </p-paginator>
    </div>
    <object *ngIf="pdfToDisplay && !msBrowsers" [data]="pdfToDisplay + '#view=FitH&zoom=100' | safeObjUrl"
            type="application/pdf" width="100%"
            height="100%"></object>
  </div>
  <div class="col-3">
    <div class="col-12" *ngIf="customizedFilePdf">
      <button type="button" [icon]="'fa fa-download'"
              [label]="'UPLOAD_COMPONENT.DOWNLOAD_FINAL' | translate" pButton
              (click)="downloadDocument()"></button>
    </div>
  </div>
</div>
